export type TourPlacement = 'top' | 'bottom' | 'left' | 'right' | 'center';

export interface ResponsiveSelector {
    mobile: string | null;
    desktop: string | null;
}

export interface TourStep {
    selector: string | ResponsiveSelector | null;
    titleKey: string;
    textKey: string;
    placement: TourPlacement | { mobile: TourPlacement; desktop: TourPlacement };
}

export function resolveSelector(step: TourStep, isMobile: boolean): string | null {
    if (!step.selector || typeof step.selector === 'string') return step.selector;
    return isMobile ? step.selector.mobile : step.selector.desktop;
}

export function resolvePlacement(step: TourStep, isMobile: boolean): TourPlacement {
    if (typeof step.placement === 'string') return step.placement;
    return isMobile ? step.placement.mobile : step.placement.desktop;
}

const tourSteps: TourStep[] = [
    {
        selector: null,
        titleKey: 'step0_title',
        textKey: 'step0_text',
        placement: 'center',
    },
    {
        selector: '[data-tour="add-word"]',
        titleKey: 'step1_title',
        textKey: 'step1_text',
        placement: 'bottom',
    },
    {
        selector: '[data-tour="search"]',
        titleKey: 'step2_title',
        textKey: 'step2_text',
        placement: 'bottom',
    },
    {
        // Mobile: tile button in nav bar; Desktop: tile button in dashboard
        selector: {
            mobile: '[data-tour="layout-controls-mobile"]',
            desktop: '[data-tour="layout-controls"]',
        },
        titleKey: 'step3_title',
        textKey: 'step3_text',
        placement: 'bottom',
    },
    {
        // Mobile: hamburger button; Desktop: first nav item in sidebar
        selector: {
            mobile: '[data-tour="navigation-mobile"]',
            desktop: '[data-tour="navigation"]',
        },
        titleKey: 'step4_title',
        textKey: 'step4_text',
        placement: {
            mobile: 'bottom',
            desktop: 'right',
        },
    },
    {
        selector: {
            mobile: '[data-tour="daily-challenge"]',
            desktop: '[data-tour="challenge-status"]',
        },
        titleKey: 'step5_title',
        textKey: 'step5_text',
        placement: 'bottom',
    },
    {
        selector: null,
        titleKey: 'step6_title',
        textKey: 'step6_text',
        placement: 'center',
    },
];

export default tourSteps;
